export default "__VITE_ASSET__DYi61tiT__"